<aside
  *ngIf="!hidden()"
  class="hint"
  role="note"
>
  <svg-icon
    class="hint__icon"
    key="info"
    size="md"
    aria-hidden="true"
  ></svg-icon>

  <div class="hint__body">
    <p
      class="hint__text"
      [innerHtml]="'COMMON.MARKDOWN_HINT.BODY' | translate"
    ></p>

    <button
      type="button"
      class="hint__more"
      (click)="toggleDetails()"
      [attr.aria-expanded]="expanded()"
    >
      {{
        (expanded() ? "COMMON.MARKDOWN_HINT.LESS" : "COMMON.MARKDOWN_HINT.MORE")
          | translate
      }}
    </button>

    <ul
      *ngIf="expanded()"
      class="hint__examples"
    >
      <li
        [innerHtml]="'COMMON.MARKDOWN_HINT.EXAMPLE_ASTERISK' | translate"
      ></li>
      <li [innerHtml]="'COMMON.MARKDOWN_HINT.EXAMPLE_HASH' | translate"></li>
      <li
        [innerHtml]="'COMMON.MARKDOWN_HINT.EXAMPLE_UNDERSCORE' | translate"
      ></li>
    </ul>
  </div>

  <button
    type="button"
    class="hint__close"
    (click)="hide()"
    [attr.aria-label]="'COMMON.MARKDOWN_HINT.HIDE_ARIA' | translate"
  >
    &times;
  </button>
</aside>

<button
  *ngIf="hidden()"
  type="button"
  class="hint__show"
  (click)="show()"
>
  {{ "COMMON.MARKDOWN_HINT.SHOW" | translate }}
</button>
